var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdjustments = function SvgAdjustments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.396a1 1 0 110-2h1.648C5.08 2.983 6.412 2 8 2c1.588 0 2.92.983 3.352 2.396H21a1 1 0 110 2h-9.645a3.502 3.502 0 01-6.71 0H3zm5 16.5a3.502 3.502 0 01-3.355-2.5H3a1 1 0 110-2h1.645a3.502 3.502 0 016.71 0H21a1 1 0 110 2h-9.645A3.502 3.502 0 018 22.896zm-5-9.5a1 1 0 110-2h9.645a3.502 3.502 0 016.71 0H21a1 1 0 110 2h-1.645a3.502 3.502 0 01-6.71 0H3zm13 .5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-8 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-14a1.5 1.5 0 001.5-1.5C9.5 4.601 8.862 4 8 4s-1.5.601-1.5 1.396a1.5 1.5 0 001.5 1.5z"
  })));
};
export default SvgAdjustments;